import { render, staticRenderFns } from "./CoverForm.vue?vue&type=template&id=276b47aa&scoped=true&"
import script from "./CoverForm.vue?vue&type=script&lang=js&"
export * from "./CoverForm.vue?vue&type=script&lang=js&"
import style0 from "./CoverForm.vue?vue&type=style&index=0&id=276b47aa&lang=less&scoped=true&"
import style1 from "./CoverForm.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276b47aa",
  null
  
)

export default component.exports